export default __webpack_public_path__ + "static/media/send.9d38aa3c.svg";